var hotRaceSlider = new Swiper("#js-hot-race-slider", {
  loop: true,
  spaceBetween: 100, // egawa add
  navigation: {
    nextEl: "#js-hot-race-slider > .slider-next",
    prevEl: "#js-hot-race-slider > .slider-prev",
  },
  pagination: {
    el: "#js-hot-race-slider > .slider-pagination",
  },
  speed: 700, // egawa add
  autoplay: { // egawa add
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
    pauseOnMouseEnter: true,
  },
});

var forecastSlider = new Swiper(".forecast-slider", {
  loop: true,
  autoplay: { // egawa add
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
    pauseOnMouseEnter: true,
  },
  navigation: {
    nextEl: ".forecast-slider-next",
    prevEl: ".forecast-slider-prev",
  },
});
